import { Controller } from "@hotwired/stimulus"

// Reusable "type-to-confirm" controller. Watches an `input` target and toggles
// the `disabled` state of one or more `submit` targets based on whether the
// input's value exactly matches the `expected` value.
//
// Usage:
//   = form_with ..., data: { controller: "components--confirm-text",
//                            "components--confirm-text-expected-value": "UNMAP TENANT" }
//     %input{ data: { action: "input->components--confirm-text#validate",
//                     "components--confirm-text-target": "input" } }
//     = ui.button(..., disabled: true,
//                 data: { "components--confirm-text-target": "submit" })
export default class extends Controller {
  static targets = ["input", "submit"]
  static values = { expected: String }

  validate() {
    const ok = this.inputTarget.value === this.expectedValue
    this.submitTargets.forEach((button) => { button.disabled = !ok })
  }
}
